import * as React from 'react';

var _path, _path2, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgWeb3 = function SvgWeb3(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_320_9102)",
        fillOpacity: 0.16,
        fillRule: "evenodd",
        d: "M54.491 14c-1.134 0-2.053.92-2.053 2.054v2.71a28 28 0 0 0-10.313-1.951C26.592 16.813 14 29.405 14 44.938s12.592 28.124 28.125 28.124S70.25 60.472 70.25 44.939c0-3.288-.564-6.443-1.6-9.376h3.296c1.135 0 2.054-.919 2.054-2.053V16.054C74 14.919 73.08 14 71.946 14z",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_320_9102)",
        fillRule: "evenodd",
        d: "M48.438 12.054c0-1.135.919-2.054 2.053-2.054h17.455c1.135 0 2.054.92 2.054 2.054v17.455c0 1.134-.92 2.053-2.054 2.053H50.491a2.054 2.054 0 0 1-2.053-2.053zM38.125 69.063q-5.841 0-10.974-2.221-5.132-2.22-8.96-6.019t-6.01-8.939T10 40.841Q10 35 12.182 29.877q2.18-5.124 6.01-8.921 3.827-3.799 8.96-5.971 5.131-2.172 10.973-2.172 1.376 0 2.803.135t2.726.405v10.12a29.163 29.163 0 0 0-5.529-8.377q-2.8 2.77-4.73 6.509-1.93 3.737-3.431 9.236h13.69v2.404H29.465a51 51 0 0 0-.51 4.048 45 45 0 0 0-.139 3.548q0 1.882.138 3.675.14 1.794.511 4.096h17.338q.373-2.302.51-4.096.14-1.793.139-3.675 0-1.2-.048-2.437a38 38 0 0 0-.24-2.875h2.481q.115 1.892.163 3.098.048 1.204.048 2.214 0 1.779-.148 3.633a56 56 0 0 1-.501 4.138h13.461a22 22 0 0 0 .893-3.747q.285-1.932.285-4.024 0-1.43-.135-2.674-.136-1.245-.502-2.638h2.578q.21 1.28.337 2.638.126 1.358.126 2.674 0 5.902-2.181 11.043t-6.01 8.94q-3.828 3.797-8.96 6.018t-10.974 2.22M13.582 48.612h13.443a44 44 0 0 1-.483-4.09 55 55 0 0 1-.13-3.68q0-1.834.139-3.687.138-1.854.492-3.91H13.582a20.4 20.4 0 0 0-.893 3.66 26.5 26.5 0 0 0-.285 3.936q0 2.092.285 4.024a22 22 0 0 0 .893 3.747M34.85 66.599q-2.434-2.85-4.411-6.978a40 40 0 0 1-2.975-8.605H14.303q3.03 6.568 8.197 10.423 5.168 3.855 12.35 5.16M14.303 30.84h13.179a44.6 44.6 0 0 1 2.969-8.41q1.869-3.951 4.32-7.137-7.061 1.065-12.277 5-5.217 3.937-8.191 10.547m23.822 35.974q3.095-3.474 5.021-7.197 1.926-3.724 3.158-8.602h-16.34q1.275 5.048 3.2 8.768t4.961 7.03m3.353-.234q6.648-1.017 12.07-5.12 5.424-4.106 8.4-10.445H48.803a57 57 0 0 1-3.254 8.678q-1.939 4.099-4.072 6.886m14.938-47.219 1.487 2.033a4.5 4.5 0 0 1 1.438-.211c1.51 0 2.583.74 2.583 2.033 0 1.143-.999 2.075-2.68 2.075-1.658 0-2.804-1.016-2.877-2.414l-3.242.55c.195 2.309 2.438 4.384 6.118 4.384 3.827 0 6.07-2.18 6.07-4.553 0-2.52-2.194-4.108-4.583-4.193l4.095-2.965V13.75H53.637v2.52h6.922z",
        clipRule: "evenodd"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_320_9102",
        x1: 14.627,
        x2: 73.165,
        y1: 43.531,
        y2: 43.531,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_320_9102",
        x1: 10.627,
        x2: 69.165,
        y1: 39.531,
        y2: 39.531,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgWeb3 as ReactComponent };
//# sourceMappingURL=Web3.svg.es.js.map
